import { render, staticRenderFns } from "./customSpecifications.vue?vue&type=template&id=71e2137e"
import script from "./customSpecifications.vue?vue&type=script&lang=js"
export * from "./customSpecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports